import React, { useEffect, useState } from 'react';
import { useToastrVanila } from '../../hooks/util/useToastrVanila';
import IFormError from '../../interfaces/IFormError';
import debounce from 'lodash.debounce';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import ICostCenter from '../../interfaces/ICostCenter';
import { useCostCenterService } from '../../hooks/services/useCostCenterService';

interface IProps {
    setCostCenter: (costCenter: ICostCenter | null) => void;
    costCenter: ICostCenter | null;
}

const SearchCostCenter = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState<readonly ICostCenter[]>([]);
    const loadingInput = open;

    const [allCostCenters, setAllCostCenters] = useState<ICostCenter[]>([]);

    const request = useCostCenterService();
    const toastr = useToastrVanila();
    const [errors, setErrors] = useState<IFormError | null>();

    useEffect(() => {
        let active = true;

        if (!loadingInput) {
            return undefined;
        }

        (async () => {
            if (active) {
                await loadCostCenters();
            }
        })();

        return () => {
            active = false;
        };
    }, [loadingInput]);

    useEffect(() => {
        setErrors(null);
    }, [open]);

    const loadCostCenters = debounce(async () => {
        setLoading(true);
        await request
            .listCostCenter()
            .then(costCenters => {
                setAllCostCenters(costCenters);
                setOptions(costCenters);
                setLoading(false);
            })
            .catch(error => {
                toastr.error(`Erro ao carregar os dados: ${error.message}`);
                setLoading(false);
            });
    }, 500);

    return (
        <Autocomplete
            open={open}
            value={props.costCenter?.id ? props.costCenter : null}
            onChange={(_e: any, newValue) => {
                props.setCostCenter(newValue ?? null);
            }}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            getOptionLabel={option =>
                option?.code ? `${option.code} - ${option.name}` : ''
            }
            options={options}
            loading={loading}
            renderInput={params => (
                <TextField
                    {...params}
                    label="Pesquisar Centro de Custo"
                    error={Boolean(errors?.code)}
                    helperText={errors?.code}
                    size="small"
                    onChange={e => {
                        const filter = e.target.value.toLowerCase();
                        const filtered = filter
                            ? allCostCenters.filter(cc =>
                                `${cc.code} - ${cc.name}`.toLowerCase().includes(filter)
                            )
                            : allCostCenters;
                        setOptions(filtered);
                    }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
};

export default SearchCostCenter;